const headerDescriptions = {
  pt: 'Acompanhe os principais indicadores de desempenho da sua operação conversacional. Essa visão reúne dados do portal Blip, permitindo entender o volume de consumo e também de conversas engajadas.',
  en: 'Track your conversational operation key performance indicators. This overview gathers data from the Blip portal, showing usage volume and engaged conversations count.',
  es: 'Monitorea los indicadores clave de rendimiento de tu operación conversacional. Este resumen recopila datos del portal Blip, lo que te permite comprender el volumen de consumo y el número de conversaciones comprometidas.',
};

export const localization = {
  pt: {
    locale: 'pt-BR',
    header: {
      title: 'Uso do Plano',
      description: headerDescriptions.pt,
      learnMore: 'Saiba mais sobre os termos.',
      modalContent: {
        title: 'Detalhamento dos termos de consumo',
        activeMessage: {
          title: 'Mensagens Ativas',
          description:'Quaisquer mensagens por disparo ativo enviadas pela empresa, independentemente do engajamento (interação ou resposta) do usuário final.',
        },
        dailyEngagedUser:{
          title: 'DEUs',
          description:'DEU (Daily Engaged User): Usuário Diário Engajado único por chatbot principal (router). Será considerado um DEU todo usuário distinto que interagir, dentro de um mesmo dia (das 00h00 às 23h59, horário de Brasília), com algum chatbot principal/router de qualquer forma, seja respondendo ou enviando uma mensagem, clicando, ou realizando qualquer outro tipo de interação. Isso inclui qualquer usuário distinto que tenha enviado pelo menos uma mensagem ao chatbot principal/router, independentemente do tipo de mensagem (texto, imagem, documento, vídeo, áudio, clique em carrossel, quick reply, emoji ou cliques), em qualquer canal (como Whatsapp, RCS, Blip Chat). Para exemplificar, caso a empresa se comunique com o mesmo usuário distinto em dois números diferentes de WhatsApp no mesmo dia, serão contabilizados dois DEUs.',
        },
        prospectConversation:{
          title: 'Adicional DEU MKT/Prospect',
          description:'DEU que teve acionamento por template de marketing, Click-to-WhatsApp, Click-to-RCS, anúncios nas plataformas Google, Meta ou TikTok, além de QR Codes e links externos em geral.',
        },
        userConversation:{
          title: 'User Conversation (UC)',
          description:'Por bot e por canal. São os DEUs (Daily Engaged Users), usuário único que interage com sua marca em um dia  por canal. Ou seja: todo usuário que enviou qualquer tipo de mensagem ou respondeu uma mensagem ativa, seja ela de texto, imagem, documento, vídeo, clique em carrossel, quick reply, etc. entre 00h e 23h59.',
        },
        aiToken:{
          title: 'Adicional IA',
          description:'DEU que teve registro de evento de consumo de tokens no Studio.',
        },
        action: 'Fechar',
      },
      showMoreButton: 'Ver mais',
    },
    chart: {
      title: 'Conversas engajadas',
      dailyEngagedUser: 'Volume total de DEUs',
      prospectConversation: 'Adicional DEU MKT/Prospect',
      userConversation: 'User Conversation',
      aiToken: 'Adicional IA',
    },
    infoPaper:{
      headerTitle: 'Consumo atual',
      activeMessage: 'Mensagens Ativas',
      dailyEngagedUser: 'Volume total de DEUs',
      prospectConversation : 'Adicional DEU MKT/Prospect',
      userConversation: 'Volume de User Conversations',
      aiToken: 'Adicional IA',
    },
  },
  en: {
    locale: 'en-US',
    header: {
      title: 'Plan Usage',
      description: headerDescriptions.en,
      learnMore: 'Learn more about the terms.',
      modalContent: {
        title: 'Detailed terms of usage',
        activeMessage: {
          title: 'Proactive messages',
          description:'Any proactively triggered messages sent by the company, regardless of whether the end-user engages (interacts or responds).',
        },
        dailyEngagedUser:{
          title: 'DEUs',
          description:'DEU (Daily Engaged User): Unique daily engaged user per main chatbot (router). Any single user who interacts with a main chatbot/router in any way within the same day (from 00:00 to 23:59 Brasília time), whether by sending or receiving a message, clicking, or performing any other type of interaction, will be counted as a DEU. This includes any single user who has sent at least one message to the main chatbot/router, regardless of the message type (text, image, document, video, audio, carousel click, quick reply, emoji, or other clicks) and across any channel (such as WhatsApp, RCS, Blip Chat). For example, if the company communicates with the same distinct user on two different WhatsApp numbers on the same day, they will be counted as two DEUs.',
        },
        prospectConversation:{
          title: 'DEU MKT/Prospect Add-on',
          description:'DEU triggered by a marketing template, Click-to-WhatsApp, Click-to-RCS, ads on Google, Meta, or TikTok, as well as QR Codes and external links in general.',
        },
        userConversation:{
          title: 'User Conversation (UC)',
          description:'By chatbot and by channel. Unique users who interact with your brand in a given day broken down by channel. In other words: every user who sent any type of message or responded to a proactive message, whether it was text, image, document, video, carousel click, quick reply, etc., between 00:00 and 23:59.',
        },
        aiToken:{
          title: 'AI Add-on',
          description:'DEU that had a token consumption event recorded in Studio.',
        },
        action: 'Close',
      },
      showMoreButton: 'See more',
    },
    chart: {
      title: 'Engaged conversations',
      dailyEngagedUser: 'Total DEUs Volume',
      prospectConversation: 'DEU MKT/Prospect Add-on',
      userConversation: 'User Conversation',
      aiToken: 'AI Add-on',
    },
    infoPaper:{
      headerTitle: 'Current usage',
      activeMessage: 'Proactive Messages',
      dailyEngagedUser: 'Total DEUs Volume',
      prospectConversation: 'DEU MKT/Prospect Add-on',
      userConversation: 'User Conversation Volume',
      aiToken: 'AI Add-on',
    },
  },
  es: {
    locale: 'es-ES',
    header: {
      title: 'Uso del Plan',
      description: headerDescriptions.es,
      learnMore: 'Obtenga más información sobre los términos.',
      modalContent: {
        title: 'Detalle de los términos de consumo',
        activeMessage: {
          title: 'Mensajes Proactivos',
          description:'Cualquier mensaje activado proactivamente enviado por la empresa, independientemente de la participación del usuario final (interacción o respuesta).',
        },
        dailyEngagedUser:{
          title: 'DEU',
          description:'DEU (Usuario Comprometido Diario): Usuario comprometido único por chatbot principal (router). Se considerará como DEU a todo usuario distinto que interactúe, dentro de un mismo día (de 00:00 a 23:59, horario de Brasília), con algún chatbot de cualquier forma, ya sea respondiendo o enviando un mensaje, haciendo clic, o realizando cualquier otro tipo de interacción. Esto incluye a cualquier usuario distinto que haya enviado al menos un mensaje al chatbot principal/router, independientemente del tipo de mensaje (texto, imagen, documento, video, audio, clic en carrusel, respuesta rápida, emoji o clics), y en cualquier canal (como WhatsApp, RCS, Blip Chat). Por ejemplo, si la empresa se comunica con el mismo usuario distinto en dos números diferentes de WhatsApp en el mismo día, se contabilizarán dos DEUs.',
        },
        prospectConversation:{
          title: 'Adicional DEU MKT/Prospect',
          description:'DEU activado por plantilla de marketing, Click-to-WhatsApp, Click-to-RCS, anuncios en las plataformas Google, Meta o TikTok, además de códigos QR y enlaces externos en general.',
        },
        userConversation:{
          title: 'User Conversation (UC)',
          description:'Por chatbot y por canal. Se refiere al usuario orgánico único que interactúa con tu marca en un día determinado por canal. En otras palabras: cada usuario que envió cualquier tipo de mensaje o respondió a un mensaje activo, ya sea texto, imagen, documento, video, clic en carrusel, respuesta rápida, etc., entre las 00:00 y las 23:59.',
        },
        aiToken:{
          title: 'Adicional IA',
          description:'DEU que registró un evento de consumo de tokens en Studio.',
        },
        action: 'Cerrar',
      },
      showMoreButton: 'Ver más',
    },
    chart: {
      title: 'Conversaciones comprometidas',
      dailyEngagedUser: 'Volumen total de DEU',
      prospectConversation: 'Adicional DEU MKT/Prospect',
      userConversation: 'Conversaciones de usuario',
      aiToken: 'Adicional IA',
    },
    infoPaper:{
      headerTitle: 'Consumo actual',
      activeMessage: 'Mensajes Activos',
      dailyEngagedUser: 'Volumen total de DEU',
      prospectConversation : 'Adicional DEU MKT/Prospect',
      userConversation: 'Volumen de conversaciones de usuarios',
      aiToken: 'Adicional IA',
    },
  },
};
